import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-load-detail-time-line-noStart.svg",
  "use": "icon-load-detail-time-line-noStart.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-load-detail-time-line-noStart.svg\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#DADCE1\" width=\"16\" height=\"16\" rx=\"8\" /><circle fill=\"#FFF\" cx=\"8\" cy=\"8\" r=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol